import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Label,
  Row,
  Col,
  Button,
  DropdownItem,
} from 'reactstrap'
import get from 'lodash/get'
import styled from 'styled-components'
import { selectColor } from '../../function'
import { FONTS, COLORS } from '../../constants'

export const Leave = (props) => {
  const open = get(props, 'open')
  const toggle = get(props, 'toggle')
  const handleRemark = get(props, 'handleRemark')
  return (
  /* eslint no-underscore-dangle: 0 */
    <Modal
      isOpen={ open }
      toggle={ () => toggle() }
    >
      <ModalHeader toggle={ () => toggle() }>
        <HeadLabel>Leave Request</HeadLabel>
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col>
              <TextLabel>Employee Name</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.name') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel>Leave Type</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.leave_type') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel>Leave Date</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.start_date') } - { get(props, 'myInbox.end_date') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel >Leave Time</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.leave_time') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel>Total Leave Day</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.days') } days
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel>Submit Date</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.created') }
              </TextInfo>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextLabel>Approver</TextLabel>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextInfo>
                { get(props, 'myInbox.approver') }
              </TextInfo>
            </Col>
          </Row>
          { get(props, 'myInbox.attachment_url', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <TextLabel>Attachments</TextLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    style={ {
                      height: 30,
                      fontFamily: 'Gotham',
                      fontSize: 12,
                    } }
                    color="info"
                    onClick={ () => window.open(get(props, 'myInbox.attachment_url'), 'blank') }
                  >Download</Button>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.status', '') !== '' &&
            <div>
              <Row>
                <Col>
                  <TextLabel>Status</TextLabel>
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInfo style={ { color: selectColor(get(props, 'myInbox.status')) } }>
                    { get(props, 'myInbox.status') }
                  </TextInfo>
                </Col>
              </Row>
            </div>
          }
          { get(props, 'myInbox.remark_request_user', '') !== '' &&
          <div>
            <Row>
              <Col>
                <TextLabel>Remarks</TextLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInfo>
                  { get(props, 'myInbox.remark_request_user') }
                </TextInfo>
              </Col>
            </Row>
          </div>
          }
          { get(props, 'myInbox.remark_approver', '') !== '' &&
          <div>
            <Row>
              <Col>
                <TextLabel >Approver Remarks</TextLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInfo>
                  { get(props, 'myInbox.remark_approver') }
                </TextInfo>
              </Col>
            </Row>
          </div>
          }
          { get(props, 'myInbox.remark_hr', '') !== '' &&
          <div>
            <Row>
              <Col>
                <TextLabel>HR Remarks</TextLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInfo>
                  { get(props, 'myInbox.remark_hr') }
                </TextInfo>
              </Col>
            </Row>
          </div>
          }
          { get(props, 'myInbox.remark_cancel', '') !== '' &&
          <div>
            <Row>
              <Col>
                <TextLabel>Cancel Remarks</TextLabel>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextInfo>
                  { get(props, 'myInbox.remark_cancel') }
                </TextInfo>
              </Col>
            </Row>
          </div>
          }
          { (get(props, 'myInbox.canApprove') || get(props, 'myInbox.canCancel')) &&
            <div>
              <DropdownItem divider />
              <TextLabel>Remarks (Optional)</TextLabel>
              <textarea
                style={ { marginBottom: '5px' } }
                className="form-control rounded-0"
                rows="3"
                onBlur={ (e) => handleRemark(e) }
              />
              { get(props, 'button') }
            </div>
          }
        </Container>
      </ModalBody>
    </Modal>
  )
}

const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const HeadLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
  padding-left: 15px;
`
const TextLabel = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: ${COLORS.BLACK};
  margin-bottom: 0px;
`




// WEBPACK FOOTER //
// ./src/components/leave-request/show-leave.js